import { useEffect } from "react";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { useTranslation } from "react-i18next";
import { observer, inject } from "mobx-react";
import { useTheme } from "styled-components";
import {
  InnerBox,
  StatusLabel,
  TextSpeech,
  BoxHeader,
  List,
  ListItem,
  getStatusColor,
} from "./Common";
import { Text, TextArea } from "../UI";
import $ from "jquery";
import { format } from "date-fns";
import { Role } from "../stores/userStore";

const NoteMessageContent = ({ note, tenantsStore, userStore, isMobile }) => {
  const { t } = useTranslation("applies");
  const theme = useTheme();

  const handleNoteSelected = (note) => {
    if (userStore.userDetails.role === Role.Tenant) {
      const body = {
        MAINCUST: userStore.userDetails.MAINCUST,
        CUST: userStore.userDetails.CUST,
        MAINENV: userStore.userDetails.MAINENV,
        CONTNAME: tenantsStore.selectedContract?.CONTNAME,
        CONT: tenantsStore.selectedContract?.CONT,
        CUSTNOTE: note.CUSTNOTE,
        DNAME: tenantsStore.selectedContract?.DNAME,
        data: {
          ZCOK_WASREADFLAG: "Y",
        },
      };
      tenantsStore.updateNote(body);
    }
  };

  useEffect(() => {
    handleNoteSelected(note);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [note]);

  const getDescription = (description) => {
    var descriptionWithNoStyle = description?.replace(
      /<style.*?<\/style>/g,
      ""
    );
    const element = $(descriptionWithNoStyle);
    var longDescription = element.text();
    return longDescription;
  };

  const renderFilesList = (list) => (
    <List>
      {list?.map(function (item, index) {
        return <ListItem backgroundImage={item.EXTFILENAME} key={index} />;
      })}
    </List>
  );

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <BoxHeader>
          {!isMobile && (
            <Text.H5 color={theme.color.gray90} style={{ textAlign: "start" }}>
              {`${note.CUSTNOTETYPEDES} /
              ${t("inquiry_number", {
                num: note.CUSTNOTE,
              })}`}
            </Text.H5>
          )}
          {isMobile && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Text.H5
                color={theme.color.gray90}
                style={{ textAlign: "start" }}
              >
                {`${note.CUSTNOTETYPEDES} /
              ${t("inquiry_number", {
                  num: note.CUSTNOTE,
                })}`}
              </Text.H5>
              <StatusLabel
                color={
                  getStatusColor(note, theme) !== theme.color.white
                    ? theme.color.white
                    : theme.color.navy
                }
                backgroundColor={getStatusColor(note, theme)}
                borderColor={
                  getStatusColor(note, theme) === theme.color.white
                    ? theme.color.palePrimary
                    : null
                }
              >
                {note.STATDES}
              </StatusLabel>
            </div>
          )}
          {!isMobile && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                marginTop: 20,
                alignItems: "center",
              }}
            >
              <StatusLabel
                color={
                  getStatusColor(note, theme) !== theme.color.white
                    ? theme.color.white
                    : theme.color.navy
                }
                backgroundColor={getStatusColor(note, theme)}
                borderColor={
                  getStatusColor(note, theme) === theme.color.white
                    ? theme.color.palePrimary
                    : null
                }
              >
                {note.STATDES}
              </StatusLabel>
              <Text.SR
                color={theme.color.gray90}
                style={{ textAlign: "start" }}
              >
                {format(
                  note.CURDATE !== undefined
                    ? new Date(note.CURDATE)
                    : new Date(),
                  "dd/MM/yyyy"
                )}
              </Text.SR>
              /
              <Text.SR
                color={theme.color.gray90}
                style={{ textAlign: "start" }}
              >
                {t("inquirer_name", {
                  name: note.NAME,
                })}
              </Text.SR>
            </div>
          )}
        </BoxHeader>
        <Text.H5
          color={theme.color.gray90}
          style={{
            textAlign: "start",
            borderBottom: "1px solid",
            borderColor: theme.color.gray70,
            padding: "5px 0",
            margin: 20,
            marginBottom: 0,
          }}
        >
          {t("subjects_title")}
        </Text.H5>
        <InnerBox>
          <Text.SR
            color={theme.color.gray90}
            style={{
              textAlign: "start",
              paddingTop: 10,
            }}
          >
            {t("subject_title")}
          </Text.SR>
          <Text.BR color={theme.color.gray90} style={{ textAlign: "start" }}>
            {note.SUBJECT}
          </Text.BR>
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 20,
              width: "100%",
              paddingTop: 10,
            }}
          >
            <div style={{ width: isMobile ? "100%" : "50%" }}>
              <Text.SR
                color={theme.color.gray90}
                style={{ textAlign: "start", paddingTop: 10 }}
              >
                {t("desc_title")}
              </Text.SR>
              <div>
                <TextArea
                  disabled={true}
                  divStyle={{
                    border: "none",
                    backgroundColor: "transparent",
                  }}
                  name="description"
                  rows={4}
                  cols={90}
                  value={getDescription(
                    note.CUSTNOTESTEXT_SUBFORM?.TEXT.replaceAll("<br>", "\n")
                  )}
                  variant="outlined"
                  multiple={true}
                ></TextArea>
              </div>
            </div>
            <div>
              <Text.SR
                color={theme.color.gray90}
                style={{ textAlign: "start" }}
              >
                {t("files_title")}
              </Text.SR>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 20,
                  marginTop: 10,
                }}
              >
                {renderFilesList(note.CUSTNOTEEXTFILE_SUBFORM)}
              </div>
            </div>
          </div>
        </InnerBox>
        <InnerBox>
          {note.CUSTNQUESTTEXT_SUBFORM?.TEXT && (
            <>
              <Text.H5
                color={theme.color.gray90}
                style={{ textAlign: "start" }}
              >
                {t("response_title")}
              </Text.H5>
              <TextSpeech style={{ width: "96%" }}>
                <Text.SR
                  color={theme.color.gray90}
                  style={{ textAlign: "start" }}
                >
                  {getDescription(note.CUSTNQUESTTEXT_SUBFORM?.TEXT)}
                </Text.SR>
              </TextSpeech>
            </>
          )}
        </InnerBox>
      </div>
    </>
  );
};

export default inject(
  "tenantsStore",
  "userStore"
)(observer(NoteMessageContent));
